import React, { useEffect, useRef, useState } from 'react';
import { checkButtonsVisibility } from '../scroller-utils';

function IconsScroller(props) {
    const [scrollToIcon, setScrollToIcon] = useState(false);
    const [dropdownToggled, setDropdownToggled] = useState(false);
    function handleDropdownClick() {
        setDropdownToggled(prev => {
            if (prev) {
                setScrollToIcon(prev => !prev);
            }
            return !prev
        });
    }

    const iconsContainer = props.iconsContainer;
    const leftPaddle = useRef(null);
    const rightPaddle = useRef(null);

    const [buttonsState, setButtonsState] = useState({
        leftPaddleEnabled: false,
        rightPaddleEnabled: false,
        dropdownEnabled: false
    });

    const [toggleCheck, setToggleCheck] = useState(false);
    useEffect(() => {
        if (iconsContainer != null) {
            setButtonsState(checkButtonsVisibility(iconsContainer));
        }
    }, [toggleCheck, iconsContainer, props.buttons?.length]);

    useEffect(() => {
        function scrollToIcon() {
            iconsContainer.scrollLeft = 0;
            const icon = iconsContainer.querySelector('.containerElementiDropdown .icona-selezionata');
            if (icon == null) {
                return;
            }
           
            let iconLeftSide = icon.getBoundingClientRect().left;
            let iconsContainerLeftSide = iconsContainer.getBoundingClientRect().left;
            iconsContainer.scrollLeft = iconLeftSide - iconsContainerLeftSide;
            setToggleCheck(prev => !prev);
        }
        
        if (iconsContainer != null) {
            scrollToIcon();
        }
    }, [scrollToIcon, iconsContainer]);
    // }, [props.buttons]);

    useEffect(() => {
        if(dropdownToggled){
            handleDropdownClick();
        }
    }, [props.id]) 

    function handleLeftPaddleClick(iconsContainer) {
        const scrollOffset = props.scrollOffset || 400;
        window.$(iconsContainer).animate({
                scrollLeft: "-="+scrollOffset,
            },
            300,
            () => {
                setToggleCheck(!toggleCheck);
            }
        );
    }

    const dropdownRef = useRef(null);
    // Chiudo il dropdown qual'ora il click fosse fuori dal box
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownToggled(false);
            }
        }

        if (dropdownToggled) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownToggled]);


    function handleRightPaddleClick(iconsContainer, leftPaddle) {
        const scrollOffset = props.scrollOffset || 400;
        const leftPaddleVisibleBeforeAnimation = buttonsState.leftPaddleEnabled;

        window.$(iconsContainer).animate({
                scrollLeft: "+="+scrollOffset,
            },
            300,
            () => {
                setToggleCheck(!toggleCheck);

                //Il rightPaddle richiede piu' logica rispetto al leftPaddle
                //perche' qualora passi da invisibile a visibile dobbiamo fare un ulteriore scrollLeft pari alla larghezza del paddle
                const leftPaddleVisibleAfterAnimation = buttonsState.leftPaddleEnabled;

                if (!leftPaddleVisibleBeforeAnimation && leftPaddleVisibleAfterAnimation) {
                    const wcs = window.getComputedStyle(leftPaddle);
                    let leftPaddleMarginLeft = parseFloat(wcs.marginLeft);
                    let leftPaddleMarginRight = parseFloat(wcs.marginRight);
                    let leftPaddleWidth = parseFloat(wcs.width);

                    iconsContainer.scrollLeft += leftPaddleMarginLeft + leftPaddleMarginRight + leftPaddleWidth;
                    setToggleCheck(!toggleCheck);
                }
            }
        );
    }

    return (
        <>
            {buttonsState.leftPaddleEnabled &&
                <div ref={leftPaddle} className="left-paddle paddle" onClick={() => { handleLeftPaddleClick(iconsContainer) }}>
                    <i className="fas fa-chevron-left"></i>
                </div>
            }
            {buttonsState.rightPaddleEnabled &&
                <div ref={rightPaddle} className="right-paddle paddle" onClick={() => { handleRightPaddleClick(iconsContainer, leftPaddle) }}>
                    <i className="fas fa-chevron-right"></i>
                </div>
            }
            {buttonsState.dropdownEnabled &&
                <div className="dropdown down-paddle" onClick={handleDropdownClick}>
                    <button className="d-flex align-items-center justify-content-center p-0">
                        <i className="fas fa-chevron-down"></i>
                    </button>
                </div>
            }
            {dropdownToggled &&
                <div className="dropdown-box" ref={dropdownRef}>
                    <div className="dropdown-box-grid">
                        {props.buttons}
                    </div>
                    <button className="close-dropdown-box-btn" onClick={handleDropdownClick}>
                        <i className="fas fa-times-circle"></i>
                    </button>
                </div>
            }
        </>
    );
}

export default IconsScroller;